export const getIframeDocument = () => {
  const iframe = document.getElementById('candyrack-frame');

  if (iframe instanceof HTMLIFrameElement) {
    const doc = iframe.contentDocument;

    return doc;
  }
};
